module.exports = __webpack_public_path__ + "static/media/ad.2f0263e0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ad.svg
// module id = 975
// module chunks = 0